module.exports = "<nz-datepicker \r\n    [(ngModel)]=\"date\" \r\n    [nzDisabledDate]=\"nzDisabledDate\" \r\n    [nzFormat]=\"'YYYY-MM-DD'\" \r\n    [nzPlaceHolder]=\"nzPlaceHolder\"\r\n    [nzSize]=\"nzSize\" \r\n    [nzDisabled]=\"nzDisabled\"\r\n    [nzAllowClear]=\"nzAllowClear\"\r\n></nz-datepicker>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/date-picker/date-picker.component.html
// module id = ../../../../../src/app/shared/components/date-picker/date-picker.component.html
// module chunks = main